const prefix = "cart-pmm-widget";
export const CART_PMM_WIDGET_TEST_IDS = {
    CART_PMM_WIDGET_CONTAINER: `${prefix}-container`,
    PMM_BANNER_CONTAINER: `${prefix}-pmm-banner-container`,
    PMM_BANNER_ARROW: `${prefix}-pmm-banner-arrow`,
    PMM_BANNER_IMAGE: `${prefix}-pmm-banner-image`,
};
